import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];
const viewport = { once: true, amount: 0.15 };

// Masked line-by-line reveal — animates on mount so above-the-fold headings always show
export const RevealLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-line">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, ease, delay: delay + i * 0.1 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Generic fade-up wrapper
export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={viewport}
    transition={{ duration: 0.8, ease, delay }}
  >
    {children}
  </motion.div>
);
